// ------------------------ ヒダの種類連動処理 ------------------------

function selectHidaByValue(value) {
  const legends = document.querySelectorAll('fieldset legend');
  let targetFieldset = null;

  legends.forEach(legend => {
    if (legend.textContent.trim() === 'ヒダの種類') {
      targetFieldset = legend.closest('fieldset');
    }
  });

  if (!targetFieldset) {
    console.warn('✘ ヒダの種類のfieldsetが見つかりません');
    return;
  }

  const input = targetFieldset.querySelector(`input[type="radio"][value="${value}"]`);
  if (input) {
    const label = document.querySelector(`label[for="${input.id}"]`);
    if (label) label.click();
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    console.log(`✔ ヒダの種類を切替: ${value}`);
  } else {
    console.warn(`✘ 該当するヒダのオプションが見つかりません: ${value}`);
  }
}

function setupSwatchToHidaLink() {
  const swatchLabels = document.querySelectorAll('.gpo-swatches label');

  swatchLabels.forEach(label => {
    label.addEventListener('click', () => {
      const labelText = label.textContent.trim();
      console.log('Swatchクリック:', labelText);
      selectHidaByValue(labelText);
    });
  });
}

// ------------------------ サイズ自動選択処理 ------------------------

function selectSizeOptionByDimensions() {
  const widthInput = document.querySelector('input[data-field-name="width"]');
  const heightInput = document.querySelector('input[data-field-name="height"]');

  const width = parseFloat(widthInput?.value);
  const height = parseFloat(heightInput?.value);
  console.log('選択処理: 幅=', width, '丈=', height);

  if (isNaN(width) || isNaN(height)) {
    console.log('→ 数値が揃っていません。処理中断');
    return;
  }

  const sizeOptions = document.querySelectorAll('input[type="radio"][name^="サイズ"][value^="W:"]');
  console.log('→ サイズ候補数:', sizeOptions.length);

  for (const option of sizeOptions) {
    const value = option.value;
    const match = value.match(/W:(\d+)-(\d+).*H:(\d+)-(\d+)/);
    if (!match) continue;

    const [_, wMin, wMax, hMin, hMax] = match.map(Number);
    if (width >= wMin && width <= wMax && height >= hMin && height <= hMax) {
      const label = document.querySelector(`label[for="${option.id}"]`);
      if (label) label.click();
      option.checked = true;
      option.dispatchEvent(new Event('change', { bubbles: true }));
      console.log('→ 該当オプション選択:', value);
      break;
    }
  }
}

function observeValueChange(inputEl, onChange) {
  let oldValue = inputEl.value;

  const observer = new MutationObserver(() => {
    if (inputEl.value !== oldValue) {
      oldValue = inputEl.value;
      console.log(`value変更検知: ${inputEl.dataset.fieldName} → ${inputEl.value}`);
      onChange();
    }
  });

  observer.observe(inputEl, { attributes: true, attributeFilter: ['value'] });
}

// ------------------------ 裏地の有無連動処理 ------------------------

function selectUrajiByValue(value) {
  const legends = document.querySelectorAll('fieldset legend');
  let targetFieldset = null;

  legends.forEach(legend => {
    if (legend.textContent.trim() === '裏地の有無') {
      targetFieldset = legend.closest('fieldset');
    }
  });

  if (!targetFieldset) {
    console.warn('✘ 裏地の有無のfieldsetが見つかりません');
    return;
  }

  const input = targetFieldset.querySelector(`input[type="radio"][value="${value}"]`);
  if (input) {
    const label = document.querySelector(`label[for="${input.id}"]`);
    if (label) label.click();
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    console.log(`✔ 裏地の有無を切替: ${value}`);
  } else {
    console.warn(`✘ 該当する裏地オプションが見つかりません: ${value}`);
  }
}

function setupDropdownToUrajiLink() {
  const dropdownItems = document.querySelectorAll('[data-element-id="dropdown-1"] .dropdown-list .dropdown-item');

  dropdownItems.forEach(item => {
    item.addEventListener('click', () => {
      const text = item.textContent.trim();
      console.log('裏地ドロップダウン選択:', text);
      selectUrajiByValue(text);
    });
  });
}

// ------------------------ 初期化処理 ------------------------

document.addEventListener('DOMContentLoaded', () => {
  console.log('初期化開始');

  // サイズ選択監視
  const sizeObserver = new MutationObserver(() => {
    const widthInput = document.querySelector('input[data-field-name="width"]');
    const heightInput = document.querySelector('input[data-field-name="height"]');
    if (widthInput && heightInput) {
      console.log('→ 幅・丈の両input検出。リスナー設定＋即時チェック実行');
      observeValueChange(widthInput, selectSizeOptionByDimensions);
      observeValueChange(heightInput, selectSizeOptionByDimensions);
      selectSizeOptionByDimensions();
      sizeObserver.disconnect();
    }
  });
  sizeObserver.observe(document.body, { childList: true, subtree: true });

  // ヒダスワッチ監視
  const hidaObserver = new MutationObserver(() => {
    const el = document.querySelector('.gpo-swatches');
    if (el) {
      console.log('→ ヒダスワッチ検出。連動処理実行');
      setupSwatchToHidaLink();
      hidaObserver.disconnect();
    }
  });
  hidaObserver.observe(document.body, { childList: true, subtree: true });

  // 裏地ドロップダウン監視
  const urajiObserver = new MutationObserver(() => {
    const el = document.querySelector('[data-element-id="dropdown-1"] .dropdown-list');
    if (el) {
      console.log('→ 裏地ドロップダウン検出。連動処理実行');
      setupDropdownToUrajiLink();
      urajiObserver.disconnect();
    }
  });
  urajiObserver.observe(document.body, { childList: true, subtree: true });
});
